/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OpenStatusFilter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import StatusTooltip from './StatusTooltip/index'
import TagStatusShortButton from 'DesignSystem/TagStatusShortButton/index'



/** @type {import('Simple/types.js').View} */
export default function OpenStatusFilter({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar/FilterByStatus/OpenStatusFilter",
  onChange,
  isHovered
  
}) {
let tabSelectedStatusesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.statuses',
format: fromFormat.isSelectedStatusOpen,
})
let tabSelectedStatusesChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.statuses',
formatOut: fromFormat.toggleSelectedStatusOpen,
})
  return (<React.Fragment
>
<TagStatusShortButton
  viewPath={`${viewPath}/TagStatusShortButton`}
 data="tab.selected.statuses"
 format="/Data/format.js isSelectedStatusOpen"
 formatOut="/Data/format.js toggleSelectedStatusOpen"
 isSelected={tabSelectedStatusesValueData}
 onClick={tabSelectedStatusesChangeData}
 text="O"
>
{childProps => (
<StatusTooltip
{...childProps}
  viewPath={`${viewPath}/StatusTooltip`}
 flowNo={!childProps.isHovered}
 flowContent={childProps.isHovered}
/>
)}
</TagStatusShortButton>
{children}
</React.Fragment>)
}